import React 							from 'react';
import ReactDOM 						from 'react-dom';

import BLComponent						from '../core/_BLComponent.jsx';
import {CustomAlert,NotificationBar} 	from '../common/_Utilities.jsx';
import ModalFrame 				from '../common/_ModalFrame.jsx';
import InputSwitch      		from '../common/_InputSwitch.jsx';
import {ClickShowTooltip}				from '../common/_Utilities.jsx';


import InventorySetInfoSection			from './inventorySetInfoSection.jsx';
import InventoryComparisonTitle 		from './inventoryComparisonTitle.jsx';
import InventoryComparisonItemListRow 	from './inventoryComparisonItemListRow.jsx';

export default class InventoryComparisonDetail extends BLComponent 
{
	constructor (props) 
	{
		super(props);
		this.state = {
			showSettingModal: false
		,	sortBy: 0  /* 0 , 1, 2, 3 Changes, Item name, Item  Number, Color */
		,	sortDirection: 0 

		}
	}

	componentDidMount()
	{
        this.initStickybar();
	}

	initStickybar() {
		const stickybarTrigger 	= this.stickybarTrigger;
		const stickybar 		= this.stickybar;

		function triggerStickybar() {
			const currentScroll = Math.round(window.scrollY);
			const stickybarTriggerTop = stickybarTrigger.offsetTop;

			if(currentScroll > stickybarTriggerTop) {				
				stickybar.classList.add('inventory-comparison__sticky-bar--show');
				if (!$(".header").hasClass("header--hidden"))
					stickybar.classList.add('inventory-comparison__bl-header-margin');
				else
					stickybar.classList.remove('inventory-comparison__bl-header-margin');
			}else{
				stickybar.classList.remove('inventory-comparison__sticky-bar--show');
			}
		}

		window.addEventListener('scroll', triggerStickybar);
	}

	render() {
		const {invDetailData, invA, invB, invASourceFrom, invBSourceFrom, invAItemNo, invBItemNo} = this.props.data;

		return(
			<React.Fragment>
				<InventoryComparisonTitle data={{inventoryComparisonSetting: this.props.data.inventoryComparisonSetting}} func={{showSettingModal: () => this.showSettingModal()}}/>
				<InventorySetInfoSection 
					data={{ isEdit: invDetailData.isEdit, invA: invA, invB: invB, invASourceFrom: invASourceFrom, invBSourceFrom: invBSourceFrom, invAItemNo: invAItemNo, invBItemNo: invBItemNo }}
					func={this.props.func}
				/>
				<section  ref={stickybarTrigger => this.stickybarTrigger = stickybarTrigger} className="l-pad-x">
					{this.renderSort()}
				</section>
				{this.renderStickyBar()} 
				{this.renderInvCompareDetail()}
				
				{this.state.showSettingModal&&this.renderSettingsModal()}
			</React.Fragment>
		)
	}

	renderSort() {
		return(
			<div className="inventory-comparison__grid-xl inventory-comparison__list-sort">
				<div className="inventory-comparison__grid-xl-cell-span--all">
					<div className="inventory-comparison__section-filter">
						<div className="inventory-comparison__sort-box l-flex">
							<div className="inventory-comparison__sort-icon text--center l-margin-y--auto l-cursor-pointer" onClick={()=>this.setState({sortDirection: ((this.state.sortDirection == 0)?1:0) })}>
								{this.state.sortDirection == 0?<i className="fas fa-sort-amount-down-alt"></i>:<i className="fas fa-sort-amount-down"></i>}
							</div>
							<select id="id-sort-by" onChange={(e)=>this.setState({sortBy : parseInt(e.target.value, 10)})} className="select select--tight seller-verification__sort-select l-cursor-pointer l-full-width" >
								<option value={0}>Differences</option>
								<option value={1}>Item name</option>
								<option value={2}>Item number</option>
								<option value={3}>Color</option>
							</select> 
						</div>
						<div className="inventory-comparison__show-sitewidthxl">
						</div>
					</div>
				</div>
			</div>
		)
	}

	renderStickyBar() {
		const {invDetailData, invA, invB} = this.props.data;

		return (
			<section ref={stickybar => this.stickybar = stickybar} className="inventory-comparison__sticky-bar">
				<div className="inventory-comparison__grid-xl">
					<div className="inventory-comparison__grid-xl-cell-span--all">
						<div className="inventory-comparison__grid-xl l-pad l-pad-bottom">
							<div className="inventory-comparison__grid-cell inventory-comparison__inv-section inventory-comparison__grid-xl-cell-span--half text--left">
								{this.renderStickyBarSetInfo(invA, 0)}
							</div>
							<div className="inventory-comparison__grid-cell inventory-comparison__inv-section inventory-comparison__grid-xl-cell-span--half text--left">
								{this.renderStickyBarSetInfo(invB, 1)}
							</div>
						</div>
						
					</div>
				</div>
			</section>
		);
	}

	renderStickyBarSetInfo(inv, target) {
		const invTitle = (target == 0 )?"Inventory A":"Inventory B";
		const invTitleSm = (target == 0 )?"Inv A":"Inv B";
		
		return (
			<div className="l-flex">
				<div>
					<img id={"img-sticky--"+target} className="inventory-comparison__set-image-sticky" src={inv.setImg} onError={()=>this.imgErrorProc(target) }/>
					<div id={"noimg-sticky--"+target} className="l-center-v inventory-comparison__color-no-img-field l-full-height l-full-width text--center l-hide">
						<div className="l-margin-y--auto l-flex l-center-v l-center l-full-height">
							<svg width="70" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
							    <path fillRule="evenodd" clipRule="evenodd" d="m15.248 5.091-.312-.312a1.5 1.5 0 0 0-1.06-.44H7.5c-.828.003-1.5.675-1.5 1.503v8.497l1.5-1.5V5.842h4.999V7.84l1.5-1.5v-.376l.188.188 1.06-1.06zM8.656 17.34l2.421-2.42.422.42 2.734-2.733a.375.375 0 0 1 .53 0l.735.734v4H8.656zM7.5 18.497v.343h8.998V9.841h-.343l1.786-1.786c.037.132.057.27.057.408V18.84a1.5 1.5 0 0 1-1.5 1.5H7.5a1.5 1.5 0 0 1-1.42-1.016 1.992 1.992 0 0 0 1.163-.57l.257-.257zm2.934-8.591A1.499 1.499 0 0 0 8.5 11.34c0 .15.022.297.064.434l1.87-1.87z" fill="#0A1E32"/>
							    <path stroke="#000" strokeWidth="2" strokeLinecap="round" d="M18 5.253 4.414 18.839"/>
							</svg>
						</div>
					</div>
				</div>
				<div className="l-margin-left">
					<div>
						{invTitle} { ( (inv != null) && ( inv.isPending ) ) && <span className="l-margin-left"><i className="fas fa-exclamation-circle"></i> Pending</span>}
					</div>
					<div>
						<strong>{inv.title}</strong>
					</div>
					<div className="inventory-comparison__hide-small-screen--flex">
						<span>
							Set ID: <strong>{inv.setId}{ (inv.setSeq != "")?"-" + inv.setSeq:"" }</strong>
						</span>
						<span className="l-margin-left">
							Source: <strong>{inv.source} data</strong>
						</span>
					</div>
					<div className="inventory-comparison__grid-cell-show-small-screen">
						<span>
							Set ID: <strong>{inv.setId}{ (inv.setSeq != "")?"-" + inv.setSeq:"" }</strong>
						</span>
						<span>
							Source: <strong>{inv.source} data</strong>
						</span>
					</div>
				</div>
			</div>
		)
	}
	
	renderInvCompareDetail() {
		return(
			<div>
				
				{this.renderInvCompareList(0)}
				{!this.props.data.inventoryComparisonSetting.hideExtraCounterAlter && this.renderInvCompareList(1)}
				{!this.props.data.inventoryComparisonSetting.hideExtraCounterAlter && this.renderInvCompareList(2)}
				{!this.props.data.inventoryComparisonSetting.hideExtraCounterAlter && this.renderInvCompareList(3)}
				
			</div>
		)
	}

	renderInvCompareList(listType) { /* listType: 0, Regular Items, 1, Extra Items, 2, Counterparts, 3: Alternate Items */
		const {invDetailData} = this.props.data;	
		const inventoryItems = (listType == 0) ? invDetailData.inventoryRegularItems : (listType == 1) ? invDetailData.inventoryExtraItems : (listType == 2) ? invDetailData.inventoryCounterParts: (listType == 3)? invDetailData.inventoryAlternateItems : null;
		const collapseList = ( (listType == 0) && (invDetailData.collapseRegular) )? true : ( (listType == 1) && (invDetailData.collapseExtra) )? true:  ( (listType == 2) && (invDetailData.collapseCounter) )? true: ( (listType == 3) && (invDetailData.collapseAlternate) )? true: false;
		
		if (inventoryItems != null)
		{
			const invCnt = this.calcInvItemQty(inventoryItems);
			return(
				<div className="l-pad-x" key={"listType" + listType}>
					{this.renderInvTypeHeader(listType, invCnt)}
					{this.renderListHeader()}

					{(collapseList)&&this.renderItemList(inventoryItems, listType)}
				</div>
			)
		}
	} 

	renderInvTypeHeader(listType, invCnt) {
		const {invDetailData} = this.props.data;
		const collapseList = ( (listType == 0) && (invDetailData.collapseRegular) )? true : ( (listType == 1) && (invDetailData.collapseExtra) )? true:  ( (listType == 2) && (invDetailData.collapseCounter) )? true: ( (listType == 3) && (invDetailData.collapseAlternate) )? true: false;
		const listTypeStr = (listType == 0) ? "Regular items" : (listType == 1) ?"Extra items" : (listType == 2) ? "Counterparts":(listType == 3) ? "Alternate items":"";;
		return (
			<div className="inventory-comparison__grid-xl-header l-margin-y inventory-comparison__cell-align-bottom">
				
					<div className="inventory-comparison__cell-align-bottom text--bold text--xl-title inventory-comparison__grid-xl-header-cell--title">
						{listTypeStr} 
					</div>
					
					<div className="inventory-comparison__cell-align-bottom inventory-comparison__grid-xl-header-cell--inv-a-info inventory-comparison__hide-small-screen">
						<span className="inventory-comparison__show-only-mobile"><strong>Inv A:</strong> {invCnt.invALotCnt} lot{(invCnt.invALotCnt != 1)?"s":""}, {invCnt.invAItemCnt} item{(invCnt.invAItemCnt != 1)?"s":""}</span>
						<span className="inventory-comparison__show-only-desktop"><strong>Inventory A:</strong> {invCnt.invALotCnt} lot{(invCnt.invALotCnt != 1)?"s":""}, {invCnt.invAItemCnt} item{(invCnt.invAItemCnt != 1)?"s":""}</span>	
					</div>

					<div className="inventory-comparison__cell-align-bottom inventory-comparison__grid-xl-header-cell--inv-b-info inventory-comparison__hide-small-screen">
						<span className="inventory-comparison__show-only-mobile"><strong>Inv B:</strong> {invCnt.invBLotCnt} lot{(invCnt.invBLotCnt != 1)?"s":""}, {invCnt.invBItemCnt} item{(invCnt.invBItemCnt != 1)?"s":""}</span>
						<span className="inventory-comparison__show-only-desktop"><strong>Inventory B:</strong> {invCnt.invBLotCnt} lot{(invCnt.invBLotCnt != 1)?"s":""}, {invCnt.invBItemCnt} item{(invCnt.invBItemCnt != 1)?"s":""}</span>
					</div>

					<div className="inventory-comparison__cell-align-bottom inventory-comparison__grid-xl-header-cell--inv-info inventory-comparison__show-only-small-screen">
						<strong>Inventory A:</strong> {invCnt.invALotCnt} lot{(invCnt.invALotCnt != 1)?"s":""}, {invCnt.invAItemCnt} item{(invCnt.invAItemCnt != 1)?"s":""}
						<span className="l-margin-left--xl"><strong>Inventory B:</strong> {invCnt.invBLotCnt} lot{(invCnt.invBLotCnt != 1)?"s":""}, {invCnt.invBItemCnt} item{(invCnt.invBItemCnt != 1)?"s":""}</span>
					</div>


					<div className="l-cursor-pointer inventory-comparison__collapse-btn text--bold inventory-comparison__grid-xl-header-cell--fold-controller l-full-height" onClick={()=>this.props.func.toggleCollapse(listType)}>
						{collapseList ? <i className="fas fa-chevron-up"></i>: <i className="fas fa-chevron-down"></i> }
					</div>
				
			</div>
		)
	}

	renderItemTypeHeader(itemType) {
		return (
			<div className="inventory-comparison__item-list inventory-comparison__grid-xl inventory-comparison__grid-xl-item-type text--bold">
				<div className="inventory-comparison__item-list inventory-comparison__grid-xl-cell-span--all inventory-comparison__table-sub-title">{itemType}</div>
			</div>
		)
	}

	renderListHeader() {
		return(
			<div className="inventory-comparison__item-list inventory-comparison__grid-xl l-margin-top inventory-comparison__grid-xl-title text--bold">
				<div className="text--left inventory-comparison__grid-xl-cell-title inventory-comparison__grid-xl-cell--image l-pad--sm">
					Image
				</div>
				<div className="text--left inventory-comparison__grid-xl-cell-title inventory-comparison__grid-xl-cell--item-no">
					Item #
				</div>
				<div className="text--left inventory-comparison__grid-xl-cell-title inventory-comparison__grid-xl-cell--item-name">
					Item Name
				</div>
				<div className="text--left inventory-comparison__grid-xl-cell-title inventory-comparison__grid-xl-cell--color">
					Color
				</div>
				<div className="text--center inventory-comparison__grid-xl-cell-title">
					Qty A
				</div>
				<div className="text--center inventory-comparison__grid-xl-cell-title">
					Qty B
				</div>
				<div className="text--left inventory-comparison__grid-xl-cell-title inventory-comparison__grid-xl-cell--color inventory-comparison__show-sitewidthxl">
					Color
				</div>
				<div className="text--left inventory-comparison__grid-xl-cell-title inventory-comparison__grid-xl-cell--item-name inventory-comparison__show-sitewidthxl">
					Item Name
				</div>
				<div className="text--right inventory-comparison__grid-xl-cell-title inventory-comparison__show-sitewidthxl">
					Design ID
				</div>
				<div className="text--right inventory-comparison__grid-xl-cell-title inventory-comparison__show-sitewidthxl">
					Image
				</div>
			</div>
		)
	}

	renderItemList(itemList, listType) {
		const data = {regularItemList: this.props.data.invDetailData.inventoryRegularItems, listType: listType}
		const listParts = itemList.filter( item => item.itemType == "Part").sort(this.sortBy).map( (item, idx)=> <InventoryComparisonItemListRow data={data} item={item} key={"Part." + idx + "_" + listType} settings={this.props.data.inventoryComparisonSetting}/> );
		const listMinifigures = itemList.filter( item => item.itemType == "Minifigure").map( (item, idx)=> <InventoryComparisonItemListRow data={data} item={item} key={"Minifigure." + idx + "_" + listType} settings={this.props.data.inventoryComparisonSetting} /> );
		const listCatalogs = itemList.filter( item => item.itemType == "Catalog").map( (item, idx)=> <InventoryComparisonItemListRow  data={data} item={item} key={"Catalog." + idx + "_" + listType} settings={this.props.data.inventoryComparisonSetting} /> );

		return(
			<React.Fragment>
				{listParts.length > 0&& 
					<div key={"itemList_part-" + listType}>
						{this.renderItemTypeHeader("Parts")}
						{listParts} 
					</div>
				}
				{listMinifigures.length > 0&& 
					<div key={"itemList_minifigures-" + listType}>
						{this.renderItemTypeHeader("Minifigures")}
						{listMinifigures} 
					</div>
				}
				{listCatalogs.length > 0&& 
					<div key={"itemList_catalogs-" + listType}>
						{this.renderItemTypeHeader("Catalogs")}
						{listCatalogs} 
					</div>
				}
				
			</React.Fragment>

		)
	}

	renderSettingsModal() {
		const {inventoryComparisonSetting} = this.props.data;
		
		return( 
			<ModalFrame title={'Inventory comparison settings'} closeFunc={() => this.closeSettingModal()} classes="modal--medium">
				<article>
					<div className="l-split l-margin-top--l inventory-comparison__show-r3-only inventory-comparison__hide-small-screen--flex">
						<div className=""><strong>Enable "widescreen mode"</strong></div>
						<div><InputSwitch classes="" onClickFunc={() => {this.props.func.updateInventoryComparisonSettings(0)}} disabled={false} isChecked={inventoryComparisonSetting.enableWideScreen} type={'dark'}/></div>
					</div>
					<div className="l-margin-top--sm inventory-comparison__show-r3-only inventory-comparison__hide-small-screen--flex">
						When this is enabled, you will be able to compare data side-by-side in browser windows wider than 1024px.
					</div>

					<div className="l-split l-margin-top--l  inventory-comparison__hide-small-screen--flex inventory-comparison__show-r3-only">
						<div className=""><strong>Show LEGO data</strong></div>
						<div><InputSwitch id="switchShowLegoData" classes="" onClickFunc={() => {this.props.func.updateInventoryComparisonSettings(1)}} disabled={false} isChecked={inventoryComparisonSetting.showLegoData} type={'dark'}/></div>
					</div>
					<div className="l-margin-top--sm inventory-comparison__hide-small-screen--flex inventory-comparison__show-r3-only">
						When this is enabled, item names, color names, and images will display as LEGO data for an inventory with its source set as LEGO data. Disabling this option will also disable “widescreen mode”.
					</div>

					<div className="l-flex l-split l-margin-top--l">
						<div className=""><strong>Hide Extras, Counterparts, and Alternates</strong></div>
						<div><InputSwitch classes="" onClickFunc={() => {this.props.func.updateInventoryComparisonSettings(2)}} disabled={false} isChecked={inventoryComparisonSetting.hideExtraCounterAlter} type={'dark'}/></div>
					</div>
					<div className="l-margin-top--sm">
						When this is enabled, Extra items, Counterparts, and Alternates will be automatically hidden when one of your sources is LEGO data.
					</div>

					<div className="l-flex l-split l-margin-top--l">
						<div className=""><strong>Always break Minifigures</strong></div>
						<div><InputSwitch classes="" onClickFunc={() => {this.props.func.updateInventoryComparisonSettings(3)}} disabled={false} isChecked={inventoryComparisonSetting.alwaysBreakMinifigures} type={'dark'}/></div>
					</div>
					<div className="l-margin-top--sm">
						When this is enabled, Minifigures will always be broken into their individual parts. This is especially helpful when comparing against an official LEGO inventory because the LEGO Group does not include assembled minifigures in their data.
					</div>
				</article>
				<div className="l-border--top l-margin-top--xl l-pad-top text--right">
					<button className="btn" onClick={() => this.closeSettingModal()} >Cancel</button><button className="btn btn--cta l-margin-left" onClick={() => this.saveSettings()}>Save</button>
				</div>
				
			</ModalFrame>
		)
	}

	zeroQtySort(a, b) {
		if ( (a.invAQty == 0) || (a.invBQty == 0) || (b.invAQty == 0) || (b.invBQty == 0) ) {
			if ( ( a.invBQty == 0) && (a.invAQty > 0) ) {
				if ( ( b.invBQty == 0) && (b.invAQty > 0) ) {
					return 0;
				}
				else
				{
					return -1;
				}
			}
			else
			{
				if ( ( b.invBQty == 0 ) && ( b.invAQty > 0 ) ) {
					return 1;
				} 
				else
				{
					return 0;
				}
			}
		}
	}

	diffQtySort(a, b) {
		if ( (a.invAQty == 0) || (a.invBQty == 0) ) {
			if ( (b.invAQty == 0) || (b.invBQty == 0) ) {
				return 0;
			}
			else
			{
				return -1;
			}
		}
		else
		{
			if ( (b.invAQty != 0) && (b.invBQty != 0) ) {
				return 0;
			}
			else
			{
				return 1;
			}
		}
	}

	qtySort(a, b) {

		if ( a.invAQty != a.invBQty) {
			if (b.invAQty != b.invBQty) {
				return 0;
			}
			else
			{
				return -1;
			}
		}
		else
		{
			if (b.invAQty == b.invBQty) {
				return 0;
			}
			else
			{
				return 1;
			}
		}
	}
	
	sortBy = (a,b) =>
	{
		var retVal = 0;
		var tmpAItemName = (a.invAItemNo == null)?"":(a.invASource === "Lego")?a.invAItemName_LEGO:a.invAItemName;
		var tmpBItemName = (b.invAItemNo == null)?"":(b.invASource === "Lego")?b.invAItemName_LEGO:b.invAItemName;

		var tmpAItemColorName = (a.invAItemNo == null)?"":(a.invASource === "Lego")?a.invAColorName_LEGO:a.invAColorName;
		var tmpBItemColorName = (b.invAItemNo == null)?"":(b.invASource === "Lego")?b.invAColorName_LEGO:b.invAColorName;

		var tmpAItemNo = ( a.invAItemNo === null )?"":a.invAItemNo;
		var tmpBItemNo = ( b.invAItemNo === null )?"":b.invAItemNo;
		switch(this.state.sortBy) {
			case 0: /* Changes */
				retVal =this.qtySort(a, b) || this.diffQtySort(a,b) || this.zeroQtySort(a,b) || tmpAItemColorName.localeCompare(tmpBItemColorName) || tmpAItemName.localeCompare(tmpBItemName);
				
				break;
			
			case 1: /* item name */  
				if (tmpAItemName != tmpBItemName)
				{
					retVal = tmpAItemName.localeCompare(tmpBItemName);
				}
				else 
				{
					retVal = a.invAColorName.localeCompare(b.invAColorName);
				}
				break;
			case 2: /* Item  Number */
				if (a.invAItemNo != b.invAItemNo)
				{
					
					retVal = tmpAItemNo.localeCompare(tmpBItemNo);
				}
				else 
				{
					retVal = tmpAItemColorName.localeCompare(tmpBItemColorName);
				}
				break;
			
			case 3:  /* Color */
				if (tmpAItemColorName != tmpBItemColorName)
				{
					retVal = tmpAItemColorName.localeCompare(tmpBItemColorName);
				}
				else 
				{
					retVal = tmpAItemName.localeCompare(tmpBItemName);
				}
				break;
		}
		
		if (this.state.sortDirection == 1) retVal *= -1;
		
		return retVal;
	}

	showSettingModal() {
		this.setState({showSettingModal:true});
	}

	closeSettingModal() {
		this.props.func.reverseInventoryComparisonSettings();
		this.setState({showSettingModal:false});
	}

	saveSettings() {
		this.props.func.saveInventoryComparisonSettings();
		this.setState({showSettingModal:false});
	}

	calcInvItemQty(invItems) {
		let invAItemCnt = 0;
		let invALotCnt = 0;
		let invBItemCnt = 0;
		let invBLotCnt = 0;

		for (const item of invItems) {
			if (item.invAQty > 0) {
				invALotCnt++;
				invAItemCnt += item.invAQty;
			}
			if (item.invBQty > 0) {
				invBLotCnt++;
				invBItemCnt += item.invBQty;
			}
		}

		return {
			invAItemCnt: invAItemCnt, 
			invALotCnt: invALotCnt, 
			invBItemCnt: invBItemCnt, 
			invBLotCnt: invBLotCnt
		}
	}

	imgErrorProc(key) {
		$("#img-sticky--" + key).hide();
		$("#noimg-sticky--" + key).show();
	}

}